/* eslint-disable import/default */
import "./public-path";
import "./services/newRelic";
import React from "react";
import { render } from "react-dom";
import configureStore, { history } from "./store/configureStore.js";
import initialState from "./reducers/initialState";
import Root from "./containers/App/Root";
import "./assets/styles/main.scss"; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.

// Create Redux store
export const store = configureStore(initialState);

// Initial render
const rootEl = document.getElementById("app");

const renderApp = (Component) => {
  render(
    <Component store={store} history={history} />,
    rootEl
  );
};

renderApp(Root);

// Hot Module Replacement for React components
if (module.hot) {
  module.hot.accept("./containers/App/Root", () => {
    const NewRoot = require("./containers/App/Root").default;
    renderApp(NewRoot);
  });
}
